const noZero = {}

noZero.install = (Vue) => {
    Vue.filter('no-zero', (val)=>{
        //val = Number(val.replace('$', ''))
        //console.log(val)
        if(val != 0) return val
        
    }) 
}

export default noZero;